
export const formatCurrency = ({ value, locale = 'cs-CZ', code = 'CZK' }) => {
  var formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
  });
  
  return formatter.format(value)
}